export { default } from './doc-upload-preview'